import { Button, Center, Skeleton, Stack, RadioGroup, Radio } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import PrePersonalizationValidationDatatableRowMeta from './PrePersonalizationValidationDatatableRowMeta';

export type TPrePersonalizationValidationDataTableData = {
    primaryKey: string | number,
    client: string,
    PAN: string,
    cardName: string,
    sequence: string,
    effectiveDate: string,
    expirationDate: string,
    operationType: string,
    ADIRTable: string,
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<TPrePersonalizationValidationDataTableData>()

export function getPrePersonalizationValidationDataTableColumns({ isLoading, handleEdit }: Props) {
  
  return [
    columnHelper.accessor("client",
        {
            id: "client",
            header: "Client",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>{props.getValue()}</Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("PAN",
        {
            id: "PAN",
            header: "PAN",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>
                        {PrePersonalizationValidationDatatableRowMeta.PAN.options &&
                        PrePersonalizationValidationDatatableRowMeta.PAN.options.map((opt, i) => (
                            opt.value == props.getValue() && 
                            <span key={i}>{opt.label}</span>
                        ))}
                    </Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("cardName",
        {
            id: "cardName",
            header: "Nom sur la Carte",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>{props.getValue()}</Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("sequence",
        {
            id: "sequence",
            header: "Sequence.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>{props.getValue()}</Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("effectiveDate",
        {
            id: "effectiveDate",
            header: "Date Effective",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>{props.getValue()}</Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("expirationDate",
        {
            id: "expirationDate",
            header: "Date Exp.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>{props.getValue()}</Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("operationType",
        {
            id: "operationType",
            header: "Type Operation",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>{props.getValue()}</Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("ADIRTable",
        {
            id: "ADIRTable",
            header: "A.D.I.R.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>
                        {PrePersonalizationValidationDatatableRowMeta.ADIRTable.options &&
                        PrePersonalizationValidationDatatableRowMeta.ADIRTable.options.map((opt, i) => (
                            opt.value == props.getValue() && 
                            <span key={i}>{opt.label}</span>
                        ))}
                    {/* <RadioGroup defaultValue={props.getValue()}>
                        <Stack spacing={5} direction="row" pt="2">
                        {PrePersonalizationValidationDatatableRowMeta.ADIRTable.options && PrePersonalizationValidationDatatableRowMeta.ADIRTable.options.map((opt, i) => (                            
                            <Radio isReadOnly key={i} value={opt.value}>
                            {opt.label}
                            </Radio>
                        ))}
                        </Stack>
                    </RadioGroup> */}
                    </Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center>
                        <Button
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}
                            mr={'1rem'}
                        >
                            Editer
                        </Button>
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
